import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
// import { checkAndRefreshAccessToken } from "../store/actions/auth";
import Layout from "../components/layout";
import { getAccessToken, getAuth } from "../utils/storage";
import AccessDenied from "../components/common/AccessDenied";
import history from "../store/history";

export default function PrivateRoute({ component: Component, hasAccess, ...rest }) {
  const dispatch = useDispatch();
  //const isLoggedIn = useSelector(state => !!state.auth.accessToken);
  const isLoggedIn = !!getAccessToken();

  const localAuth = getAuth();
  const reduxAuth = useSelector(state => (!!state.auth ? state.auth : null));

  const returnUrl = `${history?.location?.pathname}${history?.location?.search}`;


  useEffect(() => {
    //check jwt and regenerate
    if (isLoggedIn) {
      // dispatch(checkAndRefreshAccessToken());

      // *** CHECK IF MULTIPLE USER LOGIN FROM DIFFERENT TABS. REDIRECT TO HOME IF THE LOCAL STORAGE & REDUX USERS DOESN'T MATCH ***
      if (
        localAuth &&
        localAuth.username &&
        reduxAuth &&
        reduxAuth.username &&
        localAuth.username !== reduxAuth.username
      ) {
        window.location.replace(`/?retUrl=${encodeURIComponent(returnUrl)}`);
      }
    }
    // eslint-disable-next-line
  }, [dispatch, isLoggedIn, localAuth, reduxAuth]);

  // if (!isLoggedIn) {
  //   history.push(`/?retUrl=${encodeURIComponent(returnUrl)}`);
  //   return <></>;
  // }

  return (
    <Route
      {...rest}
      component={props =>
        isLoggedIn ? (
          <Layout>
            {hasAccess ?
              <Component {...props} /> : <AccessDenied />}
          </Layout>
        ) : (
          <Redirect
            to={`/?retUrl=${encodeURIComponent(returnUrl)}`}
          />
        )
      }
    />
  );
}
